export default "__VITE_ASSET__4517f7fc__"